/* MKB 2026 — Kit builder, part 5 of 5 (see mkb-builder-1.js). */
(function (K) {
  'use strict';
  var ORD = K.ORD, COLORS = K.COLORS, KITE_PTS = K.KITE_PTS, BOARD_PTS = K.BOARD_PTS, WAIST_TXT = K.WAIST_TXT, STRAP_TXT = K.STRAP_TXT, GUIDES = K.GUIDES, COPY = K.COPY, LABEL = K.LABEL, ROLE = K.ROLE;
  var esc = K.esc, uniq = K.uniq, first = K.first, clone = K.clone, num = K.num, ordOf = K.ordOf, interp = K.interp, sized = K.sized, swatch = K.swatch, round1 = K.round1, article = K.article;
  var Builder = K.Builder;

  Builder.prototype.renderAll = function () {
    var T = this.totals();
    this.root.classList.toggle('has-pkg', !!this.pkg);
    if (this.pkg) {
      this.renderRider();
      var self = this, html = '';
      this.slots.forEach(function (sl) { html += self.renderSlot(sl); });
      html += this.renderExtras();
      this.els.dyn.innerHTML = html;
    } else {
      this.els.rider.innerHTML = '';
      this.els.dyn.innerHTML = '<p class="kb-start">Pick a package to start building your kit.</p>';
    }
    this.renderSummary(T);
    this.renderBar(T);
    this.renderStage(T);
  };

  /* re-render, keeping the element the user touched in the same place on screen and keeping keyboard focus */
  Builder.prototype.update = function (anchorEl) {
    var fk = anchorEl && anchorEl.getAttribute ? anchorEl.getAttribute('data-fk') : null;
    var top = fk ? anchorEl.getBoundingClientRect().top : null;
    var hadFocus = document.activeElement === anchorEl;
    this.renderAll();
    if (fk) {
      var el = this.root.querySelector('[data-fk="' + fk.replace(/"/g, '\\"') + '"]');
      if (el) {
        var d = el.getBoundingClientRect().top - top;
        if (Math.abs(d) > 1) window.scrollBy(0, d);
        if (hadFocus) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
      }
    }
  };

  /* ---------- events ---------- */
  Builder.prototype.onClick = function (e) {
    var t = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!t || !this.root.contains(t)) return;
    var act = t.getAttribute('data-act');
    if (t.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
    var key = t.getAttribute('data-slot'), sl = key ? this.slot(key) : null, s = key ? this.st[key] : null;
    var self = this;
    this.err = '';
    switch (act) {
      case 'pkg':
        if (this.pkg && this.pkg.id === t.getAttribute('data-id')) return;
        this.choosePkg(t.getAttribute('data-id'));
        this.renderPkg();
        var b = this.root.querySelector('[data-fk="pkg-' + t.getAttribute('data-id') + '"]'); if (b) try { b.focus({ preventScroll: true }); } catch (x) {}
        return;
      case 'prod':
        if (!sl || s.h === t.getAttribute('data-h')) return;
        this.setProduct(sl, t.getAttribute('data-h'));
        this.focusKey = sl.parent || key; this.flag = null;
        this.autoAll(); this.update(t); return;
      case 'opt':
        if (!sl) return;
        this.pick(this.P[s.h], s, parseInt(t.getAttribute('data-i'), 10), t.getAttribute('data-v'));
        this.focusKey = sl.parent || key; this.flag = null;
        this.autoAll(); this.update(t); return;
      case 'extra':
        var h = t.getAttribute('data-h'), ex = this.ex[h];
        ex.on = !ex.on; this.lastExtra = ex.on ? h : null; this.focusKey = 'extras'; this.flag = null;
        this.update(t); return;
      case 'xopt':
        var ex2 = this.ex[key];
        this.pick(this.P[key], ex2, parseInt(t.getAttribute('data-i'), 10), t.getAttribute('data-v'));
        this.lastExtra = key; this.focusKey = 'extras';
        this.update(t); return;
      case 'skip': case 'unskip':
        if (!s) return;
        s.skip = act === 'skip'; this.flag = null;
        if (!s.skip) this.autoSize(sl);
        this.autoAll();
        this.update(null);
        var target = this.root.querySelector('[data-fk="' + (act === 'skip' ? 'unskip-' : 'skip-') + key + '"]');
        if (target) try { target.focus({ preventScroll: true }); } catch (x) {}
        return;
      case 'help':
        var k = t.getAttribute('data-k'); this.open[k] = !this.open[k];
        this.update(t); return;
      case 'unit':
        e.preventDefault();
        this.setUnit(t.getAttribute('data-f'), t.getAttribute('data-u'));
        return;
      case 'goto':
        e.preventDefault();
        this.goto(key);
        return;
      case 'add':
        e.preventDefault();
        var T = this.totals();
        if (T.ready === T.need && T.need > 0) this.addToCart(T);
        else if (T.next) {
          this.flag = T.next.slot === 'hook' ? 'hook' : T.next.key === 'extras' ? null : T.next.key;
          this.renderAll();
          /* bring the thing still missing (the size chips) to the middle of the screen */
          var need = this.flag ? this.root.querySelector((this.flag === 'hook' ? '.kb-hook' : '[data-step="' + this.flag + '"]') + ' .kb-need') : null;
          if (!need && T.next.slot.indexOf('x-') === 0) need = document.getElementById(this.uid + '-' + T.next.slot);
          if (need) this.scrollToY(need.getBoundingClientRect().top + (window.pageYOffset || 0) - window.innerHeight * 0.55);
          else this.goto(T.next.slot === 'hook' ? 'hook' : T.next.slot);
        }
        return;
    }
  };

  Builder.prototype.pick = function (p, s, i, val) {
    s.sel[i] = val;
    if (i === p.sizeI) s.man.size = true;
    if (i === p.colorI) {
      s.man.color = true;
      var v = this.variant(p, s.sel);
      if (p.sizeI >= 0 && s.sel[p.sizeI] != null && !(v && v.a)) { delete s.sel[p.sizeI]; s.man.size = false; }
    } else {
      this.fixColor(p, s);
    }
  };

  Builder.prototype.setUnit = function (f, u) {
    var r = this.rider, cur = r[f + 'u'];
    if (cur === u) return;
    if (r[f]) {
      if (f === 'w') r.w = u === 'kg' ? Math.round(r.w / 2.20462) : Math.round(r.w * 2.20462);
      if (f === 'x') r.x = u === 'cm' ? Math.round(r.x * 2.54) : round1(r.x / 2.54);
      if (f === 's') r.s = u === 'eu' ? round1(r.s + 33) : round1(r.s - 33);
    }
    r[f + 'u'] = u;
    var input = this.root.querySelector('[data-rider="' + f + '"]');
    if (input) { input.value = r[f] || ''; input.placeholder = { w: { lb: '165', kg: '75' }, x: { 'in': '34', cm: '86' }, s: { us: '9', eu: '42' } }[f][u]; }
    var btns = this.root.querySelectorAll('[data-act="unit"][data-f="' + f + '"]');
    for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-u') === u ? 'true' : 'false');
    this.saveRider();
    this.autoAll(); this.update(null);
  };

  Builder.prototype.onInput = function (e) {
    var t = e.target, f = t.getAttribute && t.getAttribute('data-rider');
    if (!f) return;
    var n = parseFloat(String(t.value).replace(',', '.'));
    this.rider[f] = isNaN(n) || n <= 0 ? null : n;
    this.saveRider();
    var self = this;
    clearTimeout(this.inT);
    this.inT = setTimeout(function () { self.autoAll(); self.update(null); }, 160);
  };
  Builder.prototype.saveRider = function () { try { sessionStorage.setItem('mkbKbRider', JSON.stringify(this.rider)); } catch (e) {} };

  Builder.prototype.goto = function (key) {
    var el = null;
    if (key === 'rider') el = this.root.querySelector('[data-step="rider"]');
    else if (key === 'hook') el = document.getElementById(this.uid + '-hook');
    else if (key && key.indexOf('x-') === 0) el = document.getElementById(this.uid + '-' + key) || document.getElementById(this.uid + '-extras');
    else el = document.getElementById(this.uid + '-' + key);
    if (!el) return;
    var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mkb-header-h')) || 90;
    var y = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - hh - 16;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.scrollToY(y);
    if (key !== 'rider' && key.indexOf('x-') !== 0) { this.focusKey = key === 'hook' ? 'harness' : key; }
    if (key === 'rider') { var inp = this.root.querySelector('[data-rider="w"]'); if (inp) setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (x) {} }, reduce ? 0 : 500); }
  };

  Builder.prototype.scrollToY = function (y) {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    y = Math.max(0, y);
    try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); } catch (x) { window.scrollTo(0, y); }
  };

  Builder.prototype.addToCart = function (T) {
    var self = this, qty = {}, order = [];
    T.lines.forEach(function (L) { if (L.v) { if (!qty[L.v.id]) { qty[L.v.id] = 0; order.push(L.v.id); } qty[L.v.id]++; } });
    var items = order.map(function (id) { return { id: id, quantity: qty[id], properties: { 'Package': self.pkg.title } }; });
    if (!items.length) return;
    this.busy = true; this.err = ''; this.renderAll();
    fetch(this.D.cartAdd || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'We could not add your kit. Please try again.');
        return j;
      });
    }).then(function () {
      window.location.href = self.D.cartUrl || '/cart';
    }).catch(function (err) {
      self.busy = false;
      self.err = (err && err.message ? err.message : 'We could not add your kit.') + ' Call us at ' + self.D.phone + ' and we will sort it out.';
      self.renderAll();
    });
  };

  /* The bar shows only while the builder is on screen (on the collection page the product grid follows it).
     Supersedes the syncBar in part 4. */
  Builder.prototype.syncBar = function () { this.els.bar.classList.toggle('is-on', !!this.pkg && this.rootVisible !== false && !this.sumVisible); };
  function watchRoot(b) {
    if (!b || !b.els || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { b.rootVisible = x.isIntersecting; b.syncBar(); });
    }, { rootMargin: '0px 0px -25% 0px' }).observe(b.els.steps);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-mkb-kb]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-kb-ready')) continue;
      roots[i].setAttribute('data-kb-ready', '1');
      try { roots[i].mkbKb = new Builder(roots[i]); watchRoot(roots[i].mkbKb); } catch (e) { if (window.console) console.error('[MKB kit builder]', e); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})(window.MKBKB);